export default __webpack_public_path__ + "static/desktop-changesview-c4cbffe97a95f13c6678b9b96bf0e7e6.png";